import React, { useState, useEffect } from 'react';
import './style.css';
import logoutIcon from "../../img/icon/logout.svg";
import api from '../../services/api';
import { DateTime } from 'luxon';
import { Modal, Box, Tooltip, Typography, LinearProgress, Button } from '@mui/material';
import { FillCrown } from '../Icons';
import CheckIcon from '@mui/icons-material/Check'; // Importando o ícone de check
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

export default function Time() {
    const [timeRemaining, setTimeRemaining] = useState(48 * 60 * 60); // 48 horas em segundos inicialmente
    const [showFirstAccessModal, setShowFirstAccessModal] = useState(false);
    const [freeTrial, setFreeTrial] = useState(false);
    const [data, setData] = useState<any>();
    const navigate = useNavigate();
    const [messageSent, setMessageSent] = useState(false); // Novo estado para controlar se a mensagem foi enviada

    useEffect(() => {
        const intervalId = setInterval(() => {
            setTimeRemaining(prevTime => {
                if (prevTime > 0) {
                    return prevTime - 1;
                } else {
                    clearInterval(intervalId);
                    handleCountdownEnd();
                    return 0;
                }
            });
        }, 1000);
        return () => clearInterval(intervalId);
    }, []);

    useEffect(() => {
        handleSearchTimeRemaining();
        handleSearchPlan();
    }, []);

    useEffect(() => {
        api.get('dados-usuario').then((response: any) => {
            setData(response.data);
        })

    }, [])

    const formatTimeRemaining = (time: number) => {
        const hours = Math.floor(time / 3600);
        const minutes = Math.floor((time % 3600) / 60);
        const seconds = Math.floor(time % 60);
        return `${hours.toString().padStart(2, '0')} : ${minutes.toString().padStart(2, '0')} : ${seconds.toString().padStart(2, '0')}`;
    };

    const handleSearchTimeRemaining = async () => {
        const response = await api.post('buscar-tempo-restante');
        const responseData = response.data;
        const end_date = DateTime.fromISO(responseData);
        const now = DateTime.now();
        const differenceInSeconds = Math.floor(end_date.diff(now, 'seconds').seconds);

        setTimeRemaining(differenceInSeconds);
    };

    const handleCountdownEnd = async () => {
        setShowFirstAccessModal(true);
    };

    const handleSendMessage = async () => {
        try {
            setMessageSent(true);
            await api.post('enviar-mensagem-adm', data);
        } catch (error) {
            console.error("Erro ao enviar mensagem:", error);
        }
    };

    const handleSearchPlan = async () => {
        const response = await api.post('buscar-free-trial');
        setFreeTrial(response.data);
    }

    const handleCloseModal = () => {
        navigate('/home')
    }

    return (
        <>
            <div className="countdown">
                <div className="upgrade">
                    <img src={logoutIcon} alt="Logout Icon" />
                    <h4>{formatTimeRemaining(timeRemaining)}</h4>
                </div>
            </div>
            <Modal
                open={showFirstAccessModal}
                onClose={handleCloseModal}
                style={{ backdropFilter: 'blur(15px)' }}
            >
                <Box sx={{
                    position: 'absolute',
                    top: '40%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    p: 4,
                    borderRadius: 2,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    width: '400px'
                }}>
                    <ArrowBackIcon
                        onClick={handleCloseModal}
                        style={{
                            position: 'absolute',
                            top: 16,
                            left: 16,
                            cursor: 'pointer'
                        }}
                    />
                    <FillCrown />
                    <h2 style={{ color: '#333', marginBottom: '20px' }}>Plano Expirado</h2>
                    {freeTrial === true ? (
                        <>
                            <p style={{ textAlign: 'center' }}>O seu tempo de teste terminou, para ter acesso ao sistema novamente, adquira um de nossos planos!</p>
                            <Button variant="contained" color="primary" style={{ marginTop: '20px', background: '#0d6efd', color: '#fff' }} href={`/planos`}>
                                Adquirir um Plano
                            </Button>
                        </>
                    ) : (
                        <>
                            <p style={{ textAlign: 'center' }}>O seu tempo para a criação do documento terminou, para ter acesso ao documento novamente, contate-nos!</p>
                            <Button
                                variant="contained"
                                color="primary"
                                style={{ marginTop: '20px', background: '#0d6efd', color: '#fff' }}
                                onClick={handleSendMessage}
                                disabled={messageSent}
                            >
                                {messageSent ? "Enviado" : "Enviar Mensagem"}
                                {messageSent && <CheckIcon style={{ marginLeft: '8px' }} />}
                            </Button>
                        </>
                    )}
                </Box>
            </Modal>
        </>
    );
};
